<template>
  <FilterShrink
    v-rect-loading="loading && show"
    class="ai-chat-collapse-container"
    placement="right"
    ref="filterShark"
    :class="show && 'show'"
    :style="collapseStyle"
    @open="handleOpen"
    @close="handleClose"
  >
    <iframe class="chat-ai-iframe" ref="chatAIIframe" frameborder="0" :src="chatAIIframeSrc"></iframe>
  </FilterShrink>
</template>

<script>
import FilterShrink from '@/components/common/shrink/filterShrink.vue'

export default {
  components: {
    FilterShrink
  },
  props: {
    isTalentPool: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      loading: false,
      show: false,
      collapseWidth: 330
    }
  },
  computed: {
    collapseStyle () {
      return {
        '--collapse-width': `${this.collapseWidth}px`
      }
    },
    chatAIIframeSrc () {
      if (process.env.VUE_APP_ENV === 'development') {
        return 'http://localhost:8081/recruiter-pc/chat-ai?from=iframe'
      }
      return `${location.origin}/recruiter-pc/chat-ai?from=iframe`
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    openCollapse () {
      if (this.show) {
        return
      }
      this.$refs.filterShark.handelClick()
    },
    handleAISearch (data) {
      const message = {
        name: 'sendUserMessage',
        params: {
          isTalentPool: this.isTalentPool,
          data
        }
      }
      this.$refs.chatAIIframe.contentWindow.postMessage(message, '*')
    },
    resetAiSearch () {
      const message = {
        name: 'resetAiSearch'
      }
      this.$refs.chatAIIframe.contentWindow.postMessage(message, '*')
    },
    closeAiSearch () {
      if (this.show) {
        this.$refs.filterShark.handelClick()
      }
    },
    handleOpen () {
      this.show = true
      this.$emit('open', this.collapseWidth)
    },
    handleClose () {
      this.show = false
      this.$emit('close', this.collapseWidth)
    }
  },
  watch: {
    '$i18n.locale' () {
      this.$refs.chatAIIframe.contentWindow.postMessage({
        name: 'i18nChange'
      }, '*')
    }
  }
}
</script>

<style scoped lang="scss">
.ai-chat-collapse-container {

  .chat-ai-iframe {
    flex: 1;
    padding: 14px;
  }

  ::v-deep {
    &.shrink-container {
      position: sticky;
      top: 0;
      right: 0;
      flex-shrink: 0;
    }

    .shrink-content {
      width: 0;
      overflow: hidden;
      transition: width 0.5s ease-in-out;

      .content {
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        width: var(--collapse-width);
      }
    }
  }

  &.show {
    ::v-deep {
      .shrink-content {
        width: var(--collapse-width);
        overflow: hidden auto;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 10px;
    background: none;
  }
}
</style>
